import {clamp} from '@benchling/js-utils';

import {
  DRAGGABLE_ANTIBODY_BOTTOM_MARGIN,
  DRAGGABLE_ANTIBODY_HORIZONTAL_MARGIN,
  DRAGGABLE_ANTIBODY_SIZE,
  DRAGGABLE_ANTIBODY_TOP_MARGIN,
} from 'antibodies/antibody-map/AntibodyMapConstants';

/**
 * Given a bounding box that the antibody preview should fall within and desired x- and y-coordinates for said
 * preview, make sure that the preview does not fall outside the bounding box. This function accounts for the
 * size of the antibody preview.
 * @param boundingBox The element that the antibody preview should fall within
 * @param rawX The desired x-coordinate of the top left corner of the antibody preview
 * @param rawY The desired y-coordinate of the top left corner of the antibody preview
 */
export function clampAntibodyPreviewCoordinatesToBoundingBox(
  boundingBox: HTMLElement,
  rawX: number,
  rawY: number
): [number, number] {
  const {offsetLeft, offsetTop, offsetHeight, offsetWidth} = boundingBox;
  const newX = clamp(
    offsetLeft,
    offsetWidth + offsetLeft - DRAGGABLE_ANTIBODY_SIZE - DRAGGABLE_ANTIBODY_HORIZONTAL_MARGIN,
    rawX
  );
  const newY = clamp(
    offsetTop + DRAGGABLE_ANTIBODY_TOP_MARGIN,
    offsetHeight + offsetTop - DRAGGABLE_ANTIBODY_SIZE - DRAGGABLE_ANTIBODY_BOTTOM_MARGIN,
    rawY
  );
  return [newX, newY];
}

/**
 * Given a bounding box that the antibody preview should fall within, find the bottom-right-most valid
 * location for the antibody preview.
 */
export function getDefaultAntibodyPreviewCoordinates(boundingBox: HTMLElement): [number, number] {
  const {offsetLeft, offsetTop, offsetHeight, offsetWidth} = boundingBox;
  const x = offsetWidth + offsetLeft - DRAGGABLE_ANTIBODY_SIZE - DRAGGABLE_ANTIBODY_HORIZONTAL_MARGIN;
  const y = offsetHeight + offsetTop - DRAGGABLE_ANTIBODY_SIZE - DRAGGABLE_ANTIBODY_BOTTOM_MARGIN;
  return [x, y];
}
